"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _adapter = require("@atlaskit/pragmatic-drag-and-drop/element/adapter");

var _logic = require("../logic");

var useMonitorForElements = function useMonitorForElements(instanceId, items, handleOnDrop) {
  (0, _react.useEffect)(function () {
    return (0, _adapter.monitorForElements)({
      canMonitor: function canMonitor(_ref) {
        var source = _ref.source;
        return (0, _logic.isItemData)(source.data) && source.data.instanceId === instanceId;
      },
      onDrop: function onDrop(_ref2) {
        var location = _ref2.location,
            source = _ref2.source;

        if ((0, _logic.targetIsInvalid)(location, source, items)) {
          return;
        }

        var sourceIndex = source.data.index;
        var targetIndex = items.findIndex(function (item) {
          return item.id === location.current.dropTargets[0].data.item.id;
        });
        handleOnDrop(sourceIndex, targetIndex);
      }
    });
  }, [instanceId, items, handleOnDrop]);
};

var _default = exports["default"] = useMonitorForElements;